import { Location } from 'react-router-dom';

const STORAGE_KEY = 'postLoginRedirect';
const DEFAULT_REDIRECT = '/tenants';

export const savePostLoginRedirect = (location: Location): void => {
  const path = `${location.pathname}${location.search}${location.hash}`;
  sessionStorage.setItem(STORAGE_KEY, path);
};

export const getAndClearPostLoginRedirect = (): string => {
  const path = sessionStorage.getItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_KEY);

  if (!path || !path.startsWith('/') || path.startsWith('//')) {
    return DEFAULT_REDIRECT;
  }

  return path;
};
